import { useState } from "react";
import { toast } from "sonner";
import Footer from "@/components/Footer";

export default function ContactPage() {
  const [formData, setFormData] = useState({ name: "", email: "", message: "" });
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    try {
      const res = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/contact`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData),
      });
      if (res.ok) {
        toast.success("Message sent! We'll be in touch soon.");
        setFormData({ name: "", email: "", message: "" });
      } else {
        toast.error("Something went wrong. Please try again.");
      }
    } catch {
      toast.error("Network error. Please try again.");
    }
    setSubmitting(false);
  };

  return (
    <div style={{ backgroundColor: '#050508' }}>
      {/* Hero */}
      <section className="pt-32 pb-16 px-6 md:px-12 lg:px-24" data-testid="contact-hero">
        <div className="max-w-4xl mx-auto text-center">
          <h1
  className="mt-10 md:mt-14 text-4xl sm:text-5xl lg:text-6xl font-medium leading-tight mb-6"
  style={{ fontFamily: "'Lora', serif", color: "#F5F5F5" }}
>
  Get in Touch
</h1>
          <p className="text-base md:text-lg max-w-2xl mx-auto" style={{ color: '#A1A1AA' }}>
            Ready to transform your wealth management operations? We'd love to hear from you.
          </p>
        </div>
      </section>

      {/* Contact Form */}
      <section className="pt-16 pb-32 md:pb-40 px-6 md:px-12 lg:px-24" data-testid="contact-form-section">
        <div className="max-w-xl mx-auto">
          <form onSubmit={handleSubmit} className="space-y-6" data-testid="contact-form">
            <div>
              <label className="block text-sm mb-2" style={{ color: '#F5F5F5' }}>Name</label>
              <input
                type="text"
                required
                value={formData.name}
                onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                className="w-full px-4 py-3 rounded-lg text-sm"
                style={{ 
                  backgroundColor: '#0A0A0A', 
                  border: '1px solid rgba(255,255,255,0.1)', 
                  color: '#F5F5F5',
                  outline: 'none'
                }}
                placeholder="Your name"
                data-testid="contact-name-input"
              />
            </div>
            <div>
              <label className="block text-sm mb-2" style={{ color: '#F5F5F5' }}>Email</label>
              <input
                type="email"
                required
                value={formData.email}
                onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                className="w-full px-4 py-3 rounded-lg text-sm"
                style={{ 
                  backgroundColor: '#0A0A0A', 
                  border: '1px solid rgba(255,255,255,0.1)', 
                  color: '#F5F5F5',
                  outline: 'none'
                }}
                placeholder="your@email.com"
                data-testid="contact-email-input"
              />
            </div>
            <div>
              <label className="block text-sm mb-2" style={{ color: '#F5F5F5' }}>Message</label>
              <textarea
                required
                rows={5}
                value={formData.message}
                onChange={(e) => setFormData({ ...formData, message: e.target.value })}
                className="w-full px-4 py-3 rounded-lg text-sm resize-none"
                style={{ 
                  backgroundColor: '#0A0A0A', 
                  border: '1px solid rgba(255,255,255,0.1)', 
                  color: '#F5F5F5',
                  outline: 'none'
                }}
                placeholder="Tell us about your project..."
                data-testid="contact-message-input"
              />
            </div>
            <button
              type="submit"
              disabled={submitting}
              className="w-full py-3 rounded-lg text-sm font-medium transition-colors"
              style={{ 
                backgroundColor: '#6373FA', 
                color: '#F5F5F5',
                opacity: submitting ? 0.7 : 1
              }}
              data-testid="contact-submit-btn"
            >
              {submitting ? "Sending..." : "Send Message"}
            </button>
          </form>
        </div>
      </section>


      <Footer hideWaves={true} />
    </div>
  );
}
